(function () {

    function addLightbox() {
        let images = document.querySelectorAll('.wp-block-gallery a');

        if( images.length ) {
            images.forEach(function(item) {
                item.setAttribute('data-fslightbox', 'gallery');
            });
            setTimeout(function() {
                refreshFsLightbox();
            }, 10)
        }
    }

    window.addEventListener('load', function () {
        addLightbox();
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/gallery-lightbox.js
// module id = 19
// module chunks = 0